<ng-container *transloco="let t">
  <header class="mzic-header">
    <div class="mzic-header__wrapper">
      <div
        class="mzic-header__logo"
        role="link"
        tabindex="0"
        (click)="goToHome(); openMenu.set(false)"
        (keydown.enter)="goToHome(); openMenu.set(false)"
        (keydown.space)="goToHome(); openMenu.set(false); $event.preventDefault()">
        <img src="assets/icons/mzic-logo-name.svg" />
      </div>

      <!-- Desktop Navigation -->
      <nav class="mzic-header__desktop-nav">
        <a class="mzic-header__desktop-nav__link" (click)="goToAbout()">
          {{ t('lang.menu.aboutMzic') }}
        </a>
        <a class="mzic-header__desktop-nav__link" (click)="goToMarket()">
          {{ t('lang.menu.market') }}
        </a>
      </nav>

      <!-- Mobile Menu -->
      <div class="mzic-header__menu" [ngClass]="openMenu() ? 'open' : ''">
        <nav class="mzic-header__menu__navbar" #menuNavbar>
          <ul class="mzic-header__menu__navbar__list">
            <div class="options menu-options">
              <li (click)="goToAbout()">
                {{ t('lang.menu.aboutMzic') }}
              </li>
              <li (click)="goToMarket()">
                {{ t('lang.menu.market') }}
              </li>
            </div>

            <div class="options">
              <li
                class="language-option"
                [class.language-option--active]="currentLanguage === 'pt-br'"
                (click)="switchLanguage('pt-br')">
                {{ t('lang.language.portuguese') }}
              </li>
              <li
                class="language-option"
                [class.language-option--active]="
                  currentLanguage === 'en-us' || currentLanguage === 'en'
                "
                (click)="switchLanguage('en')">
                {{ t('lang.language.english') }}
              </li>
            </div>
          </ul>
        </nav>

        <div class="mzic-header__menu__icon" (click)="handleMenuClick()">
          <span class="mzic-header__menu__icon__hamburger"></span>
        </div>
      </div>

      <div class="mzic-header__action-buttons">
        <mzic-switch-language (languageChange)="switchLanguage($event)" />
        <mzic-button class="button-primary" (click)="goToDownloadApp()">
          {{ t('lang.menu.downloadButton') }}
        </mzic-button>
      </div>
    </div>
  </header>
</ng-container>
